// packages
import { h } from 'preact';

// components
import PureComponent from '../components/PureComponent';
import asyncComponent from '../components/AsyncComponent';

// county viewer needs to be an async component, because we want it to render after fetching data
const AsyncCountyViewer = asyncComponent(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "CountyViewer" */ '../components/CountyViewer'
  )
);

class Embed extends PureComponent {
  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <AsyncCountyViewer county="Total" section="embed-full" />
      </div>
    );
  }
}

export default Embed;
